import { render, staticRenderFns } from "./planPurchase.vue?vue&type=template&id=4724c15d"
import script from "./planPurchase.vue?vue&type=script&lang=js"
export * from "./planPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports